"use client";

import { useEffect } from "react";
import Link from "next/link";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { reportClientError } from "@/lib/error-log";

/** SiteHeader lebt seit dem Doppel-Header-Bugfix (Erik 2026-08-19) in
 * app/[symbol]/layout.tsx, nicht mehr hier - siehe dortige Docstring (Next.js haelt das
 * umschliessende layout.tsx auch dann gemountet, wenn error.tsx aktiviert wird). */
export default function SymbolError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  // "error" wurde bisher gar nicht ausgewertet (nur im Typ deklariert) - beim Verdrahten
  // des Error-Trackings (STATUS.md 2026-08-06) nachgezogen, gleiches Muster wie die
  // übrigen error.tsx-Dateien.
  useEffect(() => {
    console.error("[app/[symbol]/error]", error.digest ?? "", error);
    reportClientError({ source: "app/[symbol]/error", message: error.message, stack: error.stack });
  }, [error]);

  return (
    <main className="mx-auto flex max-w-page flex-col items-center gap-8 px-4 py-24 text-center">
      <Card className="max-w-md">
        <CardContent className="pt-6">
          <p className="font-serif text-xl text-ink">Daten gerade nicht abrufbar</p>
          <p className="mt-3 text-sm text-muted-foreground">
            Die Datenquelle antwortet momentan nicht. Bitte versuche es erneut oder
            probiere es in Kürze noch einmal.
          </p>
          <div className="mt-5 flex items-center justify-center gap-4">
            <Button onClick={reset} variant="outline">
              Erneut versuchen
            </Button>
            <Link href="/" className="text-sm font-medium text-secondary hover:text-ink">
              Zurück zur Suche
            </Link>
          </div>
        </CardContent>
      </Card>
    </main>
  );
}
